/*
 * Карта «селектор → загрузчик Vue-компонента квиза».
 *
 * Держится отдельно от quiz.js и не импортирует ни Vue, ни сами компоненты
 * статически: app.js подключает только этот модуль, чтобы по QUIZ_SELECTORS
 * понять, есть ли квиз на странице, и лишь тогда тянуть Vue + Pinia.
 * Каждый import() ниже webpack выносит в собственный чанк, так что страница
 * с одним квизом не тащит остальные тринадцать.
 */
export const QUIZZES = {
  '.main-page-quiz': () => import('@/js/components/quiz/MainQuiz.vue'),
  '#quiz-vykup': () => import('@/js/components/quiz/VykupQuiz.vue'),
  '#quiz-sell': () => import('@/js/components/quiz/SellQuiz.vue'),
  '#quiz-buy': () => import('@/js/components/quiz/BuyQuiz.vue'),
  '#quiz-novostroiki': () => import('@/js/components/quiz/NovostroykiQuiz.vue'),
  '#quiz-trade-in': () => import('@/js/components/quiz/TradeinQuiz.vue'),
  '#quiz-upravlenie': () => import('@/js/components/quiz/UpravlenieQuiz.vue'),
  '#quiz-commercial-rent': () => import('@/js/components/quiz/QuizCommercialRent.vue'),
  '#quiz-commercial-sell': () => import('@/js/components/quiz/QuizCommercialSell.vue'),
  '#sdat-page-quiz': () => import('@/js/components/quiz/SdatQuiz.vue'),
  '#snyat-page-quiz': () => import('@/js/components/quiz/SnyatQuiz.vue'),
  '#quiz-outtown': () => import('@/js/components/quiz/QuizOuttown.vue'),
  '#quiz-soprovozhdenie': () => import('@/js/components/quiz/QuizSoprovozhdenie.vue'),
  '#quiz-realtor': () => import('@/js/components/quiz/QuizRealtor.vue'),
};

export const QUIZ_SELECTORS = Object.keys(QUIZZES).join(', ');
